import { AfterViewInit, Directive, ElementRef, OnChanges, OnDestroy, OnInit, inject, output } from '@angular/core';
import { Subject } from 'rxjs';

@Directive({
  selector: '[visibility]',
  standalone: true,
})
export class VisibilityDirective implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  private element = inject(ElementRef);
  private afterViewInit$ = new Subject<boolean>();
  private observer: IntersectionObserver | undefined;
  private isVisible = false;
  visibilityChange = output<boolean>();

  ngOnInit(): void {
    this.reconnectObserver();
  }

  ngOnChanges(): void {
    this.reconnectObserver();
  }

  ngAfterViewInit(): void {
    this.afterViewInit$.next(true);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  private reconnectObserver(): void {
    // Disconnect an existing observer
    this.disconnectObserver();
    // Sets up a new observer
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        const { isIntersecting: isVisible, target } = entry;
        const hasChangedVisibility = isVisible !== this.isVisible;
        const shouldEmit = isVisible || !isVisible;
        if (hasChangedVisibility && shouldEmit) {
          this.visibilityChange.emit(isVisible);
          this.isVisible = isVisible;
        }
      });
    });
    // Start observing once the view is initialized
    this.afterViewInit$.subscribe(() => {
      this.observer?.observe(this.element.nativeElement);
    });
  }

  private disconnectObserver(): void {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = undefined;
    }
  }
}
